import { Controller } from "@hotwired/stimulus";

// Live preview for CSV column mapping: updates sample values when mapping select or preview row changes.
// Uses embedded JSON (headers + sample rows) for instant updates without server requests.
export default class extends Controller {
  static targets = ["mappingRow", "sampleValue", "rowIndicator", "prevButton", "nextButton", "sampleNav"];
  static values = {
    sampleRows: Array,
    headers: Array,
    interpreted: Object,
    datetimeTargets: Array,
    interpretationMode: String
  };

  connect() {
    this.rowIndex = 0;
    const rows = this.sampleRowsValue || [];
    if (rows.length > 0) {
      this.updateRowIndicator();
    }
    this.refreshAllSampleValues();
  }

  interpretationModeValueChanged() {
    this.refreshAllSampleValues();
  }

  onSelectChange(event) {
    const row = event.target.closest("tr");
    if (!row) return;
    const targetField = row.dataset.targetField;
    const selectedHeader = event.target.value;
    this.updateSampleValueForRow(row, targetField, selectedHeader);
  }

  prevRow() {
    if (this.rowIndex <= 0) return;
    this.rowIndex--;
    this.updateRowIndicator();
    this.refreshAllSampleValues();
  }

  nextRow() {
    if (this.rowIndex >= this.sampleRowsValue.length - 1) return;
    this.rowIndex++;
    this.updateRowIndicator();
    this.refreshAllSampleValues();
  }

  updateRowIndicator() {
    if (!this.hasRowIndicatorTarget) return;
    const total = this.sampleRowsValue.length;
    this.rowIndicatorTarget.textContent = total > 0
      ? `${this.rowIndex + 1} of ${total}`
      : "No rows";
    this.updatePrevNextButtons();
  }

  updatePrevNextButtons() {
    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = this.rowIndex <= 0;
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = this.rowIndex >= Math.max(0, this.sampleRowsValue.length - 1);
    }
  }

  updateSampleValueForRow(row, targetField, selectedHeader) {
    const span = row.querySelector("[data-csv-mapping-preview-target='sampleValue']");
    if (!span) return;
    span.textContent = this.getSampleValue(selectedHeader, targetField) || "—";
  }

  refreshAllSampleValues() {
    this.mappingRowTargets.forEach((row) => {
      const targetField = row.dataset.targetField;
      const select = row.querySelector("select");
      const selectedHeader = select ? select.value : "";
      this.updateSampleValueForRow(row, targetField, selectedHeader);
    });
  }

  getSampleValue(header, targetField) {
    if (!header || !this.sampleRowsValue.length) return "";
    const row = this.sampleRowsValue[this.rowIndex];
    if (!row) return "";
    const val = row[header];
    return val != null && String(val).trim() !== "" ? String(val).trim() : "";
  }
}
